import { reactive, ref } from "vue";

export const mousePosition = reactive({
  clientX: 0,
  clientY: 0,
});
